import React from 'react';
import { getClass } from '../../../../utils/component-helpers';

export default props => {
  const orgLi = (
    <li className="organization">
      <div className="org" onClick={() => props.switchOrg(props.org)}>
        {props.label}
      </div>
    </li>
  );

  const orgType = props.orgPrefix === 'P' ? 'publisher' : 'merchant';
  const adminOrgLi = (
    <li className="organization">
      <div
        className={getClass('org-label', {
          'merchant-label': props.orgPrefix === 'R',
        })}
        onClick={() => props.switchOrg(props.org)}
      >
        <span className={`org-prefix ${orgType}`}>{props.orgPrefix}</span>
        <span className="org-name">{props.label}</span>
      </div>
    </li>
  );

  return props.isAdmin ? adminOrgLi : orgLi;
};
